import React from 'react';

export default function Textarea({
  label,
  placeholder,
  value,
  name,
  onChange,
  onBlur,
  disabled,
  errors,
  touched,
}) {
  return (
    <div className="w-full">
      <label
        htmlFor={name}
        className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
      >
        {label}
      </label>
      <textarea
        rows="8"
        className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-primary-500 focus:border-primary-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-primary-500 dark:focus:border-primary-500"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        type="text"
        name={name}
        id={name}
        disabled={disabled}
      />
      {errors && touched && (
        <div className="text-red-500 text-sm mt-1">{errors}</div>
      )}
    </div>
  );
}
